import { styled, Typography } from '@mui/material'

const SecondaryDarkTypography = styled(Typography)(() => ({
  color: '#6C6C6C',
}))

export default SecondaryDarkTypography
